var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30518 3.44434H3.44406C3.07571 3.44434 2.72244 3.59066 2.46197 3.85113C2.2015 4.1116 2.05518 4.46487 2.05518 4.83322V14.5554C2.05518 14.9238 2.2015 15.2771 2.46197 15.5375C2.72244 15.798 3.07571 15.9443 3.44406 15.9443H13.1663C13.5346 15.9443 13.8879 15.798 14.1484 15.5375C14.4088 15.2771 14.5552 14.9238 14.5552 14.5554V9.69434",
    stroke: "#93989C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5138 2.40315C13.7901 2.12688 14.1648 1.97168 14.5555 1.97168C14.9462 1.97168 15.3209 2.12688 15.5972 2.40315C15.8734 2.67942 16.0286 3.05412 16.0286 3.44482C16.0286 3.83552 15.8734 4.21022 15.5972 4.48649L8.99995 11.0837L6.22217 11.7782L6.91661 9.00037L13.5138 2.40315Z",
    stroke: "#93989C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconDisabled);
export default __webpack_public_path__ + "static/media/edit-icon-disabled.2eaa1af3153fa55d206667261b84fd79.svg";
export { ForwardRef as ReactComponent };